module.exports = __webpack_public_path__ + "img/ИФ-1(А)-016-m.18b0ba4c.png";